import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllCompanyLocationsEndpoint } from "~/modules/client/api/companyLocation/companyLocationApiEndpoints.ts";
import type { CompanyLocation } from "~/modules/client/api/companyLocation/companyLocationTypes.ts";

export const getAllCompanyLocations = (): AxiosApiResponsePromise<CompanyLocation[]> => axiosApi.get(getAllCompanyLocationsEndpoint);
